<template>
  <v-dialog v-model="showModal" max-width="800px" persistent>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card v-else>      
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showModal = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>                    
        </v-toolbar>                
        <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="saving"></v-progress-linear>          
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-container  grid-list-xl>
            <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="Podaj twoje hasło*" v-validate="'required'" name="current_user_password" id="current_user_password"
              :error-messages="errors.collect('current_user_password')" data-vv-as="Twoje hasło" v-model="current_user_password" type="password"></v-text-field>                 
            </v-flex>             
            <v-flex d-flex xs12>
              <v-layout row wrap>
              <v-flex  xs6 >
                <v-text-field label="Hasło*" v-validate="'required'" name="password" id="password"  data-vv-as="Hasło" :error-messages="errors.collect('password')" v-model="password" ref="password" :type="'password'" :append-icon="'fa-eye-slash'"></v-text-field>
              </v-flex>
              <v-flex   xs6>
                <v-text-field label="Powtórz hasło*" v-validate="'confirmed:password'" name="password_confirmation_reset" id="password_confirmation_reset" :error-messages="errors.collect('password_confirmation_reset')"  :append-icon="'fa-eye-slash'"  data-vv-as="'powtórz hasło'"  :type="'password'"></v-text-field>
              </v-flex>       
              </v-layout>       
            </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        </v-card-text>
        <v-card-actions>
           <v-spacer></v-spacer>
          <v-btn @click="closeForm" color="error">Zamknij</v-btn>
          <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userService } from "@/services/";
import swal from "sweetalert";

export default {
  name: "ResetPassword",
  data() {
    return {
      title: "Zmiana hasła użytkownika",
      saving: false,
      current_user_password: null,
      password: null,
      visibility_class: "row",
      loading: false
    };
  },
  props: ["id", "visible"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.resetPassword();
        }
      });
    },
    hide() {
      this.visibility_class = "row scale-transition scale-out";
      this.saving = true;
    },
    show() {
      this.visibility_class = "row";
      this.saving = false;
    },
    resetPassword() {
      this.hide();
      userService
        .resetPassword({
          adminPassword: this.current_user_password,
          userId: this.id,
          newPassword: this.password
        })
        .then(() => {
          swal("Gotowe", "Zresetowano hasło", "success");
          this.saving = false;
          this.closeForm();
        })
        .catch(resp => {
          if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
          ) {
            this.showError(false, resp.response.data.error.message);
          } else {
            this.showError(false, "Błąd resetu hasła");
          }
        });
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.visible;
      },
      set: function(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  watch: {
    visible: function(newVal)
    {
        if (!newVal) {
          this.errors.clear();
        } else {
          this.current_user_password = null;
          this.password = null;
        }
    }
  }
};
</script>

<style>
</style>
